import NamedFilters from '../named-filters'
import WpPluginFilters from './wp-plugin-filters'

export default class WpNamedPluginFilters extends WpPluginFilters {
  static getFilterTypeName() {
    NamedFilters.getFilterTypeName()
  }
}
